import styled from '@emotion/styled';

export const Step4Wrapper = styled.section``;
